import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import back from '../../assests/images/back_pg.png'
const Back = (props) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.pageYOffset > 0);
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
   <div className="header navbar-fixed">
  <nav className={scrolled ? 'scrolled top_nav' : 'top_nav'}>
    <div className="h_left">
      <Link  to={-1} className="btn_tp icon_sq">
        <img src={back} alt="back_pg" />
      </Link>
    </div>
  </nav>
</div>

  )
}

export default Back
